import { ButtonLink } from "@/components/ButtonLink";
import { useI18n } from "@/i18n/I18nProvider";

export function NotFound() {
  const { t } = useI18n();

  return (
    <section className="not-found">
      <div className="section-inner narrow-copy" data-reveal>
        <h1>{t("notFound.title")}</h1>
        <p>{t("notFound.body")}</p>
        <ButtonLink href="/">{t("nav.home")}</ButtonLink>
      </div>
    </section>
  );
}
